// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"a7b066a8","686":"7833f243","930":"9ae9b976"}[chunkId] + ".chunk.css";
};